import { Tabs, Tab, Box } from '@mui/material';
import React, { FC } from 'react';
import { AppTab } from '../models';

interface AppTabsProps {
    appTabsList: AppTab[];
    handleTabChange?: (index: number) => void;
}

export const AppTabsContainer: FC<AppTabsProps> = ({ appTabsList, handleTabChange }) => {
    const [value, setValue] = React.useState<number>(0);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        if(handleTabChange) {
            handleTabChange(newValue)
        }
    };

    return (
        <Box id="tabs-box">
            <Box id="tabs-list" className="border-b border-divider mb-4">
                <Tabs value={value} onChange={handleChange}>
                    {appTabsList.map((appTab: AppTab) => (
                        <Tab key={appTab.index} label={appTab.label} id={appTab.label} />
                    ))}
                </Tabs>
            </Box>
            <Box id="tab-content">{appTabsList[value].content}</Box>
        </Box>
    );
};
